import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantRoleEdit',
  props: {
    item: {
      type: Object,
      required: true
    },
    ruleList: {
      type: Array,
      required: true
    },
    tenantId: {
      type: Number,
      required: false,
      default: () => 0
    }
  },
  data: function () {
    return {
      tagSearch: ''
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    roleIsValid() {
      return (this.item.name || '').trim().length > 0 && (this.item.Rules || []).length > 0;
    },
    buttons() {
      return [{
        icon: 'fas fa-save',
        action: 'saveRole',
        title: this.item.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.create'),
        tooltip: this.item.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.create'),
        valid: this.roleIsValid
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    saveRole() {
      const newRole = cloneDeep(this.item);
      const selectedRules = newRole.Rules;
      delete newRole.Rules;
      newRole.rules = selectedRules;
      if (newRole.description === null) {
        delete newRole.description;
      }
      if (this.tenantId) {
        newRole.tenantId = this.tenantId;
      }
      let savePromise = undefined;
      if (!newRole.id) {
        savePromise = ApiService.createRole(newRole);
      } else {
        savePromise = ApiService.updateRole(newRole);
      }
      const context = this;
      savePromise.then(() => {
        // allow the role-cache to be cleared
        setTimeout(function () {
          context.$emit('roleSaved');
        }, 500);
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack('Could not save role', 'error');
        }
      });
    },
    isFederatedAuthRole(itemName) {
      const regex = /^OIDC_\d+_/;
      return regex.test(itemName);
    }
  }
};